import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllCashPaymentLinksData,
  fetchAllOnlinePaymentLinksData,
} from "../../../redux/reducers/apiSlice";
import {
  convertThenFormat,
  formatTimezoneThenStraight,
  date_format_wrong_date,
  currentDateOfTheMonth,
} from "../../../components/common-data/Converts";
import {
  BiBoxArrowUpRightIcon,
  CallIcon,
  EmailIcon,
  PersonIcon,
} from "../../../images/icons/icons";
import CommonTable from "../../../components/common-components/common-tables/CommonTable";
import PaymentLinkFilters from "../../../components/payment-link-system/PaymentLinkFilters";
import {
  approvalStatus,
  paymentStatus,
} from "../../../components/common-data/DropdowData";

const HomePMLinkDetails = ({ clickedCard, prevFilters, userInfoData }) => {
  const dispatch = useDispatch();
  const {
    allOnlinePaymentLinkData,
    allCashPaymentData,
    allOnlinePaymentLinkDataLoading,
    allCashPaymentDataLoading,
  } = useSelector((state) => state.api);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const isShowPmLink =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilters = {
    searchString: "",
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.uid ||
            userInfoData?.user_id ||
            "",
        }
      : "",
    selectedPaymentType: "",
    selectedStatus:
      clickedCard === "online_completed"
        ? paymentStatus.find((item) => item.value === "completed")
        : clickedCard === "online_pending"
        ? paymentStatus.find((item) => item.value === "pending")
        : "",
    selectedApprovalStatus:
      clickedCard === "cash_approved"
        ? approvalStatus.find((item) => item.value === "1")
        : clickedCard === "cash_pending"
        ? approvalStatus.find((item) => item.value === "0")
        : "",
    selectedCreator: "",
    selectedSubsType: "",
    selectedPlan: "",
    selPaymentSource: "",
    selectedStartDate: currentDateOfTheMonth,
    selectedEndDate: currentDateOfTheMonth,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const initialFilters = {
    ...prevFilters,
    page: isPage + 1,
    limit: pageLimit,
    gym_id: allFilters.selectedGym?.value || "",
    added_by_id: allFilters.selectedCreator?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    is_partial: allFilters.selectedPaymentType?.value || "",
    type: allFilters.selectedSubsType?.value || "",
    duration: allFilters.selectedPlan?.value || "",
    payment_through: allFilters.selPaymentSource?.value || "",
    status: allFilters.selectedStatus?.value || "",
    is_approved: allFilters.selectedApprovalStatus?.value || "",
    // start_date: currentDateOfTheMonth,
    // end_date: currentDateOfTheMonth,
    // is_approved:
    //   clickedCard === "cash_approved"
    //     ? 1
    //     : clickedCard === "cash_pending"
    //     ? 0
    //     : "",
    // status:
    //   clickedCard === "online_completed"
    //     ? "completed"
    //     : clickedCard === "online_pending"
    //     ? "pending"
    //     : "",
  };
  const [filters, setFilters] = useState(initialFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniTbDatas = {
    onlineTbata: [],
    onlinePagination: [],

    cashTbata: [],
    cashPagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const isCashPayment = clickedCard?.includes("cash");
  const isOnlinePayment =
    clickedCard?.includes("online") || clickedCard?.includes("total_online");

  const onResetFilters = () => {
    setAllFilters(iniAllFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getOnlinePMLinks(filters) {
    const { is_approved, ...rest } = filters;

    dispatch(
      fetchAllOnlinePaymentLinksData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getCashPMLink(filters) {
    const { status, ...rest } = filters;

    dispatch(
      fetchAllCashPaymentLinksData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getCombineReload(filters) {
    if (isOnlinePayment) {
      getOnlinePMLinks(filters);
    } else if (isCashPayment) {
      getCashPMLink(filters);
    }
  }

  useEffect(() => {
    getCombineReload(filters);
  }, [filters]);

  useEffect(() => {
    setFilters({
      page: isPage + 1,
      limit: pageLimit,
      gym_id: allFilters.selectedGym?.value || "",
      added_by_id: allFilters.selectedCreator?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      is_partial: allFilters.selectedPaymentType?.value || "",
      type: allFilters.selectedSubsType?.value || "",
      duration: allFilters.selectedPlan?.value || "",
      payment_through: allFilters.selPaymentSource?.value || "",
      status: allFilters.selectedStatus?.value || "",
      is_approved: allFilters.selectedApprovalStatus?.value || "",
    });
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedStatus,
    allFilters.selectedCreator,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selectedPaymentType,
    allFilters.selectedSubsType,
    allFilters.selectedPlan,
    allFilters.selPaymentSource,
    allFilters.selectedApprovalStatus,
  ]);

  useEffect(() => {
    if (isOnlinePayment) {
      setTbDatas((prevs) => ({
        ...prevs,
        onlineTbata: allOnlinePaymentLinkData?.data || [],
        onlinePagination: allOnlinePaymentLinkData?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        cashTbata: allCashPaymentData?.data || [],
        cashPagination: allCashPaymentData?.pagination || [],
      }));
    }
  }, [allOnlinePaymentLinkData, allCashPaymentData]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const onlineTableColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || ""}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || ""}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "created_by",
      text: "Created By Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.created_by || "NA"}</span>;
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "amount",
      text: "link / total Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.link_value || 0)}/
            {JSON.parse(row?.req_body)
              ? convertThenFormat(JSON.parse(row.req_body)?.price || 0)
              : 0}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Link Created On",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row.date_added.length <= 10
              ? date_format_wrong_date(row.date_added)
              : date_format_wrong_date(row.date_added)}
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        return (
          <span className={`tb-data ${row?.is_partial === 1 ? "tb-link" : ""}`}>
            {row?.is_partial === 1
              ? "Partial"
              : row?.is_partial === 0
              ? "Full"
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "payment_through",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_through || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Payment Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.status === "completed"
                ? "tb-badge-success"
                : row?.status === "pending"
                ? "tb-badge-success-1"
                : "not-assigned"
            }`}
          >
            {!isShowPmLink && row?.status === "pending"
              ? "Link Sent"
              : row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    isShowPmLink && {
      dataField: "payment_link",
      text: "Payment Link",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.payment_link === 1 ? "tb-link" : ""}`}
          >
            {row?.payment_link ? (
              <a
                className=""
                rel="noreferrer"
                target="_blank"
                href={row.payment_link}
              >
                <BiBoxArrowUpRightIcon />
              </a>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
  ];

  const cashTableColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || ""}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || ""}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "created_by",
      text: "Created By Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.created_by || "NA"}</span>;
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "amount",
      text: "link / total Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.link_value || 0)}/
            {JSON.parse(row.req_body)
              ? convertThenFormat(JSON.parse(row.req_body)?.price || 0)
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row.date_added ? formatTimezoneThenStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        return (
          <span className={`tb-data ${row?.is_partial === 1 ? "tb-link" : ""}`}>
            {row?.is_partial === 1
              ? "Partial"
              : row?.is_partial === 0
              ? "Full"
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "payment_through",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_through || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Approval Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.is_approved === 1
                ? "tb-badge-success"
                : row?.is_approved === 0
                ? "tb-badge-success-1"
                : "not-assigned"
            }`}
          >
            {!isShowPmLink && row?.is_approved === 0
              ? "Link Sent"
              : row?.is_approved === 1
              ? "Approved"
              : row?.is_approved === 0
              ? "Pending"
              : row?.is_approved === -1
              ? "Not Approved"
              : "Can_ed/Resent" || "-"}
          </span>
        );
      },
    },
    isShowPmLink && {
      dataField: "payment_link",
      text: "Payment Link",
      formatter: (_, row) => {
        return (
          <>
            {row?.is_approved === 1 ? (
              <span className="tb-data tb-badge tb-badge-success">
                Completed
              </span>
            ) : !isShowPmLink ? (
              <span className="tb-data tb-badge tb-badge-success-1">
                link sent
              </span>
            ) : (
              <span className="tb-data tb-badge tb-badge-success-2">
                <a
                  className=""
                  rel="noreferrer"
                  target="_blank"
                  href={`https://wtfgyms.com//cash-details/${row?.uid}`}
                >
                  <BiBoxArrowUpRightIcon />
                </a>
              </span>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <PaymentLinkFilters
        decryptedText={userInfoData}
        paymentTableFilters={allFilters}
        setPaymentFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        onClickReset={onResetFilters}
        isLoading={allOnlinePaymentLinkDataLoading || allCashPaymentDataLoading}
        isReload={() => {
          getCombineReload(filters);
        }}
      />

      <div className="common-table-container mt15">
        <CommonTable
          tableData={isOnlinePayment ? tbDatas.onlineTbata : tbDatas.cashTbata}
          tablePagination={
            isOnlinePayment ? tbDatas.onlinePagination : tbDatas.cashPagination
          }
          tableColumns={isCashPayment ? cashTableColumns : onlineTableColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={
            allOnlinePaymentLinkDataLoading || allCashPaymentDataLoading
          }
        />
      </div>
    </>
  );
};

export default HomePMLinkDetails;
